import { render, staticRenderFns } from "./CardLikeButtons.vue?vue&type=template&id=2e6c5c18&scoped=true&"
import script from "./CardLikeButtons.vue?vue&type=script&lang=js&"
export * from "./CardLikeButtons.vue?vue&type=script&lang=js&"
import style0 from "./CardLikeButtons.vue?vue&type=style&index=0&id=2e6c5c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c5c18",
  null
  
)

export default component.exports